module.exports = __webpack_public_path__ + "img/view-icon.33fe1c4e.svg";